import { ReactElement } from 'react';
import { Box, Flex, Grid, Heading, Text } from '../../atoms';
import { QuickLinkProps } from './components/quick-link';

type QuickLinksProps = {
  title?: string;
  subHeading?: string;
  children?: ReactElement<QuickLinkProps> | Array<ReactElement<QuickLinkProps>>;
};

function QuickLinks({
  title,
  subHeading,
  children
}: QuickLinksProps): JSX.Element {
  return (
    <Box
      data-testid="quick-links-container"
      padding="space_unit.x4"
      border="1px solid"
      borderColor="gray.50"
      borderRadius="10px"
    >
      <Flex direction="column">
        <Heading as="h2" variant="h4" size="md">
          {title ?? 'Quick Links'}
        </Heading>
        <Text fontSize=".8rem" color="palette_gray.60">
          {subHeading ?? `Important Actions, in the palm of your hand`}
        </Text>
      </Flex>
      <Grid
        data-testid="quick-links-grid"
        templateColumns="repeat(2, 1fr)"
        gap={4}
        mt="space_unit.x4"
        flexWrap="wrap"
      >
        {children}
      </Grid>
    </Box>
  );
}

export { QuickLinks };
